import MellatImg from "assets/mellatbank1.jpg"
const PosSetting = () => {
    return (<>
        <div className="flex gap-4">
            <div>
                <a className="flex flex-col gap-3 rounded-md place-content-center justify-center cursor-pointer border shadow-sm text-center p-2 flex-wrap" href="https://chortke.app/desktop/pos_installation_guide.rar" target="_blank"
                    rel="noreferrer">
                    <img src={MellatImg} alt="به پرداخت بانک ملت" />
                    <span>فایل های مورد نیاز دستگاه کارت خوان بانک ملت</span>
                </a>
            </div>
        </div>
    </>);
}

export default PosSetting;